import { SidenavItem } from './sidenav-item';
let system = localStorage.getItem('p_system');
let _items;
if (system == 'tert') {

    _items = [
        {
            id: 1, name: 'General', _name: 'dashboard', icon: 'dashboard',
            sub: [
                { id: 1, name: 'Dashboard', _name: 'dashboard', icon: 'dashboard' }
            ]
        },
        {
            id: 2, name: 'Profile', _name: 'profile', icon: 'account_box',
            sub: [
                { id: 1, name: 'My Profile', _name: 'my-profile', icon: 'account_box' },
                { id: 2, name: 'Change Password', _name: 'change-passcode', icon: 'lock' },
                { id: 3, name: 'Documents', _name: 'document-list', icon: 'folder' },
            ]
        },
        {
            id: 3, name: 'Academics', _name: 'academics', icon: 'school',
            sub: [
                { id: 1, name: 'Course Registration', _name: 'course-registration', icon: 'toc' },
                { id: 2, name: 'Resources', _name: 'resources', icon: 'book' },
                { id: 3, name: 'Registration History', _name: 'registration-history', icon: 'archive' },
                { id: 4, name: 'Semester Result', _name: 'semester-result', icon: 'view_list' },
                { id: 5, name: 'View Timetable', _name: 'view-timetable', icon: 'table_chart' },
                // { id: 6, name: 'video_resources', _name:'v-resouces', icon:'book'},
                // { id: 7, name: 'watch_resources', _name:'watch-resource', icon:'personal_video'}
            ]
        },
        {
            id: 4, name: 'Payments', _name: 'payments', icon: 'payment',
            sub: [
                { id: 1, name: 'Pay Tuition', _name: 'pay-tuition', icon: 'payment' },
                { id: 2, name: 'Payment History', _name: 'payment-history', icon: 'credit_card' },
                { id: 3, name: 'Transaction History', _name: 'transaction-history', icon: 'payment' },
            ]
        },
        {
            id: 5, name: 'Others', _name: 'others', icon: 'account_box',
            sub: [
                { id: 1, name: 'Notice Board', _name: 'notice-board', icon: 'notifications' },
                { id: 2, name: 'Accomodation', _name: 'accomodation', icon: 'home' },
                { id: 3, name: 'Election', _name: 'election', icon: 'done' },
                { id: 4, name: 'Certificate', _name: 'certificate', icon: 'crop_landscape' },
                { id: 5, name: 'Help', _name: 'help', icon: 'contact_support' },
                { id: 6, name: 'Logout', _name: 'logout', icon: 'account_box' }
            ]
        }

        // {id:3, name:'Payments', color:'black'},
        // {id:4, name:'Academics', color:'black'},
        // {id:5, name:'Home', color:'black'},
        // {id:6, name:'Logout', color:'black'},
    ]
} else if (system == 'psec') {
    _items = [
        {
            id: 1, name: 'General', _name: 'dashboard', icon: 'dashboard',
            sub: [
                { id: 1, name: 'Dashboard', _name: 'dashboard', icon: 'dashboard' }
            ]
        },
        {
            id: 2, name: 'Profile', _name: 'profile', icon: 'account_box',
            sub: [
                { id: 1, name: 'My Profile', _name: 'my-profile', icon: 'account_box' },
                { id: 2, name: 'Change Password', _name: 'change-passcode', icon: 'lock' },
            ]
        },
        {
            id: 3, name: 'Academics', _name: 'academics', icon: 'school',
            sub: [

                // { id: 1, name: 'Result', _name: 'semester-result', icon: 'view_list' },
                // { id: 2, name: 'Result', tag: "New", _name: 'term-report-sheets', icon: 'view_list' },
                { id: 2, name: 'Result', _name: 'term-report-sheets', icon: 'view_list' },
                { id: 3, name: 'Weighted Report', _name: 'weighted-report-sheets', icon: 'view_list' },

                { id: 4, name: 'Resources', _name: 'resources', icon: 'book' },
                { id: 5, name: 'View Timetable', _name: 'view-timetable', icon: 'table_chart' }
            ]
        },
        {
            id: 4, name: 'Payments', _name: 'payments', icon: 'payment',
            sub: [
                { id: 1, name: 'Pay Tuition', _name: 'pay-tuition', icon: 'payment' },
                { id: 2, name: 'Payment History', _name: 'payment-history', icon: 'credit_card' },
                { id: 3, name: 'Transaction History', _name: 'transaction-history', icon: 'payment' },
            ]
        },
        {
            id: 5, name: 'Others', _name: 'others', icon: 'account_box',
            sub: [
                { id: 1, name: 'Notice Board', _name: 'notice-board', icon: 'notifications' },
                { id: 2, name: 'Accomodation', _name: 'accomodation', icon: 'home' },
                { id: 3, name: 'Certificate', _name: 'certificate', icon: 'crop_landscape' },
                { id: 4, name: 'Help', _name: 'help', icon: 'contact_support' },
                { id: 5, name: 'Logout', _name: 'logout', icon: 'power_settings_new' }
            ]
        }


        // {id:3, name:'Payments', color:'black'},
        // {id:4, name:'Academics', color:'black'},
        // {id:5, name:'Home', color:'black'},
        // {id:6, name:'Logout', color:'black'},
    ]
}
const ITEMS = _items
export default ITEMS;